export default __webpack_public_path__ + "static/media/sunset.6749d450.png";